var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface5352338"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(11.372549%,11.372549%,11.372549%)",
      fillOpacity: 1
    },
    d: "M 14 4 C 8.488281 4 4 8.488281 4 14 L 4 36 C 4 41.511719 8.488281 46 14 46 L 36 46 C 41.511719 46 46 41.511719 46 36 L 46 14 C 46 8.488281 41.511719 4 36 4 Z M 14 6 L 36 6 C 40.429688 6 44 9.570312 44 14 L 44 36 C 44 40.429688 40.429688 44 36 44 L 14 44 C 9.570312 44 6 40.429688 6 36 L 6 14 C 6 9.570312 9.570312 6 14 6 Z M 13 15 C 11.355469 15 10 16.355469 10 18 L 10 32 C 10 33.644531 11.355469 35 13 35 L 37 35 C 38.644531 35 40 33.644531 40 32 L 40 18 C 40 16.355469 38.644531 15 37 15 Z M 13.414062 17 L 36.582031 17 L 27.675781 25.894531 C 26.183594 27.382812 23.796875 27.382812 22.304688 25.890625 Z M 38 18.410156 L 38 31.585938 L 31.402344 25 Z M 12 18.414062 L 18.585938 25 L 12 31.585938 Z M 29.988281 26.410156 L 36.585938 33 L 13.414062 33 L 20 26.414062 L 20.890625 27.304688 C 23.144531 29.558594 26.832031 29.5625 29.089844 27.308594 Z M 29.988281 26.410156 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.54abcf2afe1a77564306efd12ead0571.svg";
export { ForwardRef as ReactComponent };